import React from "react";

import { useTranslation } from "react-i18next";

import { CaretDoubleLeftIcon } from "@phosphor-icons/react";

import {
  TrackingPipelineEvents,
  AnalyticsEvents,
} from "~/sdks/LocalContent/types";

import { useTracking } from "@local-logic/core/tracking";
import { useRootElement } from "../context";

import { Title } from "./Title";
import { CloseButton } from "./CloseButton";

import * as styles from "./styles";

export function Header({ title }: { title?: string | boolean }) {
  const { t } = useTranslation("localContent");
  const tracking = useTracking();
  const { activeScore, isExpanded, onToggleIsExpanded } = useRootElement();

  const handleOnArrowClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    const eventAttributes = {
      currentActiveScore: activeScore || "none",
      currentIsExpanded: isExpanded,
    };

    tracking.postEvent({
      eventType: TrackingPipelineEvents.SIDEBAR_TOGGLE_CLICKED,
      eventAttributes: Object.entries(eventAttributes).map(([key, value]) => ({
        label: key,
        data: value,
      })),
    });

    tracking.trackAnalyticsEvent({
      eventName: AnalyticsEvents.SIDEBAR_TOGGLE_CLICKED,
      eventAttributes,
    });

    onToggleIsExpanded();
  };

  return (
    <div className={styles.container} data-testid="sidebar-header">
      {isExpanded && !activeScore && <Title title={title} />}
      {isExpanded && activeScore && <CloseButton />}
      <button
        type="button"
        onClick={handleOnArrowClick}
        aria-label={t("sidebar.header.toggle.ariaLabel", {
          context: isExpanded ? "close" : "open",
        })}
        aria-pressed={isExpanded}
        data-testid="sidebar-header-toggle"
      >
        <CaretDoubleLeftIcon
          className={styles.icon}
          aria-hidden="true"
          focusable="false"
          data-testid="sidebar-header-toggle-icon"
        />
      </button>
    </div>
  );
}
